import { createApp } from 'vue'
import App from './App.vue'
import router from './router'

import './assets/styles.css';

createApp(App).use(router).mount('#app')

if ("serviceWorker" in navigator) {
    navigator.serviceWorker.register("/service-worker.js").then(() => {
      console.log("Service Worker registered!");
    });
  }
  